import React from 'react';
import './Skills.css';

const Skills = ({ data }) => {
  const { id, icon, label, color } = data;
  return (
    <div className="skills" key={id}>
      <p
        className="skills__button"
        style={{ color: color, fontSize: 30, marginRight: 30 }}
      >
        {icon}
      </p>
      <p className="skills__label">{label}</p>
    </div>
  );
};

export default Skills;
